import { Flex } from '@radix-ui/themes'
import { WALLET_PROVIDER_ICONS } from 'features/auth/constants'
import { getSolanaConnectorProviders } from 'features/auth/utils/get-solana-connector-providers'
import { RadixText, XyroLoading } from 'shared/ui'
import { useConnectSolanaWallet } from '../../hooks/use-connect-solana-wallet'
import type { SolanaConnectorProvider } from '../../utils/get-solana-connector-providers'
import { AuthButton } from '../auth-buttons'
import { PolicyAgreementTextWithLinks } from './policy-agreement-text-with-links'

export const SolanaAuthWizardStepWalletConnect: React.FC = () => {
  const connectorProviders = getSolanaConnectorProviders()
  const { handleAuthWallet, loading } = useConnectSolanaWallet()

  const handleConnectWalletProvider = async (
    provider: SolanaConnectorProvider
  ) => {
    await handleAuthWallet(provider)
  }

  return (
    <Flex
      direction='column'
      justify='center'
      align='stretch'
      width={'100%'}
      gap={'4'}
    >
      {connectorProviders.map(provider => {
        const { id, name } = provider
        const connectorLogoIcon =
          WALLET_PROVIDER_ICONS[id as keyof typeof WALLET_PROVIDER_ICONS]

        return (
          <AuthButton
            key={id}
            disabled={loading}
            onClick={() => handleConnectWalletProvider(provider)}
          >
            <XyroLoading loading={loading}>
              {connectorLogoIcon}
              <RadixText>{name}</RadixText>
            </XyroLoading>
          </AuthButton>
        )
      })}

      <PolicyAgreementTextWithLinks />
    </Flex>
  )
}
